module.exports = __webpack_public_path__ + "static/image4-6676613017b4ef4ff3a8cb9101710276.jpg";